import { HTMLAttributes, useContext } from 'react';
import { CaretDownNextIcon } from '@glu/icons-react';
import AccordionPanelContext from '../AccordionPanel/AccordionPanelContext';
import useStyles from './AccordionIcon.styles';

const AccordionPanelHeaderIcon = ({ className, title, ...rest }: HTMLAttributes<SVGElement>) => {
  const { isOpen } = useContext(AccordionPanelContext);
  const classes = useStyles();
  return (
    <CaretDownNextIcon
      className={`${classes.icon} ${isOpen ? classes.iconRotated : ''} ${className}`}
      focusable={false}
      title={title}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...rest}
    />
  );
};

export default AccordionPanelHeaderIcon;
